import { CLEAR_CHAT } from '../constants'

export function reducer(state, action) {
  if (action.type == CLEAR_CHAT) {
    return {
      ...state,
      whatsapp: {
        ...state.whatsapp,
        chat: []
      }
    }
  }
  return state
}